import {SET_SUBMIT_FORM} from "@/store/mutations.type";
import {SET_FORM_ERRORS} from "@/store/mutations.type";

const mutations = {
    [SET_SUBMIT_FORM](state, submitForm) {
        state.submitForm = submitForm;
    },
    [SET_FORM_ERRORS](state, formErrors) {
        state.formErrors = formErrors;
        console.log(state.formErrors);
    }
}

export default mutations;